export const USER_LIST = 'USER_LIST';
export const USER_LIST_SUCCESS = 'USER_LIST_SUCCESS';
export const USER_LIST_ERROR = 'USER_LIST_ERROR';

export const ROU_USER_DETAILS = 'ROU_USER_DETAILS';
export const ROU_USER_DETAILS_SUCCESS = 'ROU_USER_DETAILS_SUCCESS';
export const ROU_USER_DETAILS_ERROR = 'ROU_USER_DETAILS_ERROR';

export const CRO_USER_DETAILS = 'CRO_USER_DETAILS';
export const CRO_USER_DETAILS_SUCCESS = 'CRO_USER_DETAILS_SUCCESS';
export const CRO_USER_DETAILS_ERROR = 'CRO_USER_DETAILS_ERROR';

export const USER_ALLOCATION = 'USER_ALLOCATION';
export const USER_ALLOCATION_SUCCESS = 'USER_ALLOCATION_SUCCESS';
export const USER_ALLOCATION_ERROR = 'USER_ALLOCATION_ERROR';

export const FILTER_CHAINAGE = 'FILTER_CHAINAGE';

export const SUPERVISOR_USER_DETAILS = 'SUPERVISOR_USER_DETAILS';
export const SUPERVISOR_USER_DETAILS_SUCCESS = 'SUPERVISOR_USER_DETAILS_SUCCESS';
export const SUPERVISOR_USER_DETAILS_ERROR = 'SUPERVISOR_USER_DETAILS_ERROR';

export const LINEWALKER_USER_DETAILS = 'LINEWALKER_USER_DETAILS';
export const LINEWALKER_USER_DETAILS_SUCCESS = 'LINEWALKER_USER_DETAILS_SUCCESS';
export const LINEWALKER_USER_DETAILS_ERROR = 'LINEWALKER_USER_DETAILS_ERROR';

export const NPV_USER_DETAILS = 'NPV_USER_DETAILS';
export const NPV_USER_DETAILS_SUCCESS = 'NPV_USER_DETAILS_SUCCESS';
export const NPV_USER_DETAILS_ERROR = 'NPV_USER_DETAILS_ERROR';

export const EDIT_USER_ALLOCATION = 'EDIT_USER_ALLOCATION';
export const EDIT_USER_ALLOCATION_SUCCESS = 'EDIT_USER_ALLOCATION_SUCCESS';
export const EDIT_USER_ALLOCATION_ERROR = 'EDIT_USER_ALLOCATION_ERROR';

export const ADD_ALLOCATION = 'ADD_ALLOCATION';
export const ADD_ALLOCATION_SUCCESS = 'ADD_ALLOCATION_SUCCESS';
export const ADD_ALLOCATION_ERROR = 'ADD_ALLOCATION_ERROR';

export const EDIT_ALLOCATION = 'EDIT_ALLOCATION';
export const EDIT_ALLOCATION_SUCCESS = 'EDIT_ALLOCATION_SUCCESS';
export const EDIT_ALLOCATION_ERROR = 'EDIT_ALLOCATION_ERROR';

export const ALLOCATION_USER_DETAILS = 'ALLOCATION_USER_DETAILS';
export const ALLOCATION_USER_DETAILS_SUCCESS = 'ALLOCATION_USER_DETAILS_SUCCESS';
export const ALLOCATION_USER_DETAILS_ERROR = 'ALLOCATION_USER_DETAILS_ERROR';

export const ALLOCATION_SUB = 'ALLOCATION_SUB';
export const ALLOCATION_SUB_SUCCESS = 'ALLOCATION_SUB_SUCCESS';
export const ALLOCATION_SUB_ERROR = 'ALLOCATION_SUB_ERROR';

export const ALLOCATION_PIPELINE_PATH = 'ALLOCATION_PIPELINE_PATH';
export const ALLOCATION_PIPELINE_PATH_SUCCESS = 'ALLOCATION_PIPELINE_PATH_SUCCESS';
export const ALLOCATION_PIPELINE_PATH_ERROR = 'ALLOCATION_PIPELINE_PATH_ERROR';

export const EDIT_ALLOCATION_PIPELINE_PATH = 'EDIT_ALLOCATION_PIPELINE_PATH';
export const EDIT_ALLOCATION_PIPELINE_PATH_SUCCESS = 'EDIT_ALLOCATION_PIPELINE_PATH_SUCCESS';
export const EDIT_ALLOCATION_PIPELINE_PATH_ERROR = 'EDIT_ALLOCATION_PIPELINE_PATH_ERROR';

export const INSPECTION_LIST = 'INSPECTION_LIST';
export const INSPECTION_LIST_SUCCESS = 'INSPECTION_LIST_SUCCESS';
export const INSPECTION_LIST_ERROR = 'INSPECTION_LIST_ERROR';

export const USERS_LIST = 'USERS_LIST';
export const USERS_LIST_SUCCESS = 'USERS_LIST_SUCCESS';
export const USERS_LIST_ERROR = 'USERS_LIST_ERROR';

export const LOG_LIST = 'LOG_LIST';
export const LOG_LIST_SUCCESS = 'LOG_LIST_SUCCESS';
export const LOG_LIST_ERROR = 'LOG_LIST_ERROR';



export const TASK_LIST = 'TASK_LIST';
export const TASK_LIST_SUCCESS = 'TASK_LIST_SUCCESS';
export const TASK_LIST_ERROR = 'TASK_LIST_ERROR';

export const TASK_LIST_DETAILS = 'TASK_LIST_DETAILS';
export const TASK_LIST_DETAILS_SUCCESS = 'TASK_LIST_DETAILS_SUCCESS';
export const TASK_LIST_DETAILS_ERROR = 'TASK_LIST_DETAILS_ERROR';

export const ADD_TASK_LIST_DETAILS = 'ADD_TASK_LIST_DETAILS';
export const ADD_TASK_LIST_DETAILS_SUCCESS = 'ADD_ASK_LIST_DETAILS_SUCCESS';
export const ADD_TASK_LIST_DETAILS_ERROR = 'ADD_TASK_LIST_DETAILS_ERROR';

export const UPDATE_TASK_LIST = 'UPDATE_TASK_LIST';
export const UPDATE_TASK_LIST_DETAILS_SUCCESS = 'UPDATE_TASK_LIST_DETAILS_SUCCESS';
export const UPDATE_TASK_LIST_DETAILS_ERROR = 'UPDATE_TASK_LIST_DETAILS_ERROR';

export const DELETE_TASK_LIST = 'DELETE_TASK_LIST_DETAILS';
export const DELETE_TASK_LIST_SUCCESS = 'DELETE_TASK_LIST_DETAILS_SUCCESS';
export const DELETE_TASK_LIST_ERROR = 'DELETE_TASK_LIST_DETAILS_ERROR';

export const GEOFENCE_MANAGEMENT_LIST = 'GEOFENCE_MANAGEMENT_LIST';
export const GEOFENCE_MANAGEMENT_LIST_SUCCESS = 'GEOFENCE_MANAGEMENT_LIST_SUCCESS';
export const GEOFENCE_MANAGEMENT_LIST_ERROR = 'GEOFENCE_MANAGEMENT_LIST_ERROR';



export const SCHEDULE_LIST = 'SCHEDULE_LIST';
export const SCHEDULE_LIST_SUCCESS = 'SCHEDULE_LIST_SUCCESS';
export const SCHEDULE_LIST_ERROR = 'SCHEDULE_LIST_ERROR';

export const DELETE_SCHEDULE = 'DELETE_SCHEDULE';
export const DELETE_SCHEDULE_SUCCESS = 'DELETE_SCHEDULE_SUCCESS';
export const DELETE_SCHEDULE_ERROR = 'DELETE_SCHEDULE_ERROR';

export const  SCHEDULE_DETAILS = 'SCHEDULE_DETAILS';
export const SCHEDULE_DETAILS_SUCCESS = 'SCHEDULE_DETAILS_SUCCESS';
export const SCHEDULE_DETAILS_ERROR = 'SCHEDULE_DETAILS_ERROR';

export const SCHEDULE_UPDATE = 'SCHEDULE_UPDATE';
export const SCHEDULE_UPDATE_SUCCESS = 'SCHEDULE_UPDATE_SUCCESS';
export const SCHEDULE_UPDATE_ERROR = 'SCHEDULE_UPDATE_ERROR';

export const ADD_SCHEDULE = 'ADD_SCHEDULE';
export const ADD_SCHEDULE_SUCCESS = 'ADD_SCHEDULE_SUCCESS';
export const ADD_SCHEDULE_ERROR = 'ADD_SCHEDULE_ERROR';

export const QRT_USER_DETAILS = 'QRT_USER_DETAILS';
export const QRT_USER_DETAILS_SUCCESS = 'QRT_USER_DETAILS_SUCCESS';
export const QRT_USER_DETAILS_ERROR = 'QRT_USER_DETAILS_ERROR';

export const NOTIFICATION_MANAGEMENT_LIST = 'NOTIFICATION_MANAGEMENT_LIST';
export const NOTIFICATION_MANAGEMENT_LIST_SUCCESS = 'NOTIFICATION_MANAGEMENT_LIST_SUCCESS';
export const NOTIFICATION_MANAGEMENT_LIST_ERROR = 'NOTIFICATION_MANAGEMENT_LIST_ERROR';

export const OPTIONAL_PATH_LIST = 'OPTIONAL_PATH_LIST';
export const OPTIONAL_PATH_LIST_SUCCESS = 'OPTIONAL_PATH_LIST_SUCCESS';
export const OPTIONAL_PATH_LIST_ERROR = 'OPTIONAL_PATH_LIST_ERROR';


export const DELETE_OPTIONAL_PATH = 'DELETE_OPTIONAL_PATH';
export const DELETE_OPTIONAL_PATH_SUCCESS = 'DELETE_OPTIONAL_PATH_SUCCESS';
export const DELETE_OPTIONAL_PATH_ERROR = 'DELETE_OPTIONAL_PATH_ERROR';

export const OPTIONAL_PATH_LIST_DETAILS = 'OPTIONAL_PATH_LIST_DETAILS';
export const OPTIONAL_PATH_LIST_DETAILS_SUCCESS = 'OPTIONAL_PATH_LIST_DETAILS_SUCCESS';
export const OPTIONAL_PATH_LIST_DETAILS_ERROR = 'OPTIONAL_PATH_LIST_DETAILS_ERROR';